import { IOption, IOptionServiceDTO, OptionBase } from './option';

export interface IFilterServiceDTO {
  Name: string;
  Summary: string;
  Title: string;
  Options: IOptionServiceDTO[];
}

export interface IFilter {
  filterable: boolean;
  key: string;
  options: IOption[];
  summary: string;
  title: string;
  value: string;

  hasValue(): boolean;
  id(): string;
  /**
   * Build string tempalte identifier depending on filter's type.
   * @returns {string} A string template identifier for further rendering.
   */
  template(): string;
}

export class Filter implements IFilter {
  public static initFromService(cfg: IFilterServiceDTO, templateSuffix: string): Filter {
    if (cfg === null || typeof cfg !== 'object') {
      return undefined;
    }

    const options: IOptionServiceDTO[] = cfg.Options || [];

    return new Filter(cfg.Name, options.length === 1 ? 'checkbox' : 'radio', templateSuffix, {
      options: options.map((option: IOptionServiceDTO) => {
        return {
          title: option.Title,
          value: option.Value,
        };
      }),
      summary: cfg.Summary,
      title: cfg.Title,
    });
  }

  public key: string;
  public value: string;
  public summary: string;
  public title: string;
  public type: string;
  public options: IOption[];
  public filterable: boolean;

  private idSuffix = '';
  private templateSuffix: string;

  constructor(key: string, type: string, templateSuffix: string, cfg?: any) {
    if (cfg === null || typeof cfg !== 'object') {
      cfg = {};
    }

    this.templateSuffix = templateSuffix;
    this.key = key;
    this.filterable = typeof cfg.filterable === 'boolean' ? cfg.filterable : true;
    this.value = '';
    this.summary = cfg.summary || '';
    this.title = cfg.title || '';
    this.type = type || '';
    this.options = (cfg.options || []).map((o: any) => new OptionBase(this.type, o));

    this.idSuffix = String(Math.random()).substr(2);
  }

  public hasValue(): boolean {
    return typeof this.value === 'string' && this.value !== '';
  }

  public id(): string {
    return this.key.toLowerCase().replace(/\s/g, '-') + '_' + this.idSuffix;
  }

  public template(): string {
    if (this.key === 'Product_Mobcolorhex') {
      return this.templateSuffix + 'color.html';
    }

    return this.templateSuffix + this.type + '.html';
  }
}
